import {
  GET_BUYERS_PROVIDERS_SIZE,
  GET_BUYERS_PROVIDERS_SIZE_ERROR,
  GET_BUYERS_PROVIDERS_SIZE_SUCCESS
} from './BuyersProvidersSizeSection.actions'

const buyersProvidersSizeSectionState = {
  csv: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The buyers providers size section's reducer.
 */
const buyersProvidersSizeSectionReducer = (state = buyersProvidersSizeSectionState, { payload, type }) => {
  switch (type) {
    case GET_BUYERS_PROVIDERS_SIZE: {
      return { ...state, loading: true }
    }
    case GET_BUYERS_PROVIDERS_SIZE_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_BUYERS_PROVIDERS_SIZE_SUCCESS: {
      return { ...state, csv: payload.csv, data: payload.data, loading: false }
    }
    default: {
      return state
    }
  }
}

export default buyersProvidersSizeSectionReducer
